var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('aup-hero'),_vm._v(" "),_c('v-container',[_c('div',{staticClass:"py-10",domProps:{"innerHTML":_vm._s(_vm.$store.state.wp.pageContent)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }